<template>
  <div>
    <Breadcrumbs main="" :title="$t('lbl_EMPBE_NewsInfoCenter')" />
    <div class="b-sidebar-backdrop bg-dark" style="z-index: 100" v-if="sidebarMenu" @click="handleSidebarHide"></div>
    <b-overlay :show="loadingSponsor" rounded="sm">
    <visitorPermission :Permission="newsActiviateLimit > 0 || isAdmin">
      <template v-slot:body>
        <div class="container-fluid">
          <div class="">
            <div class="row">
              <newsListing ref="news" :hideSidebarNavMenu="hideSidebarNavMenu" :newsActiviateLimit="newsActiviateLimit">
              </newsListing>
              <b-sidebar id="newsRightpopup" class="customSidebar" title="" right bg-variant="white" v-model="sidebarMenu"
                :no-header-close="true" :shadow="true" :visible="currentRouteName != 'NewsInfoCenter'"
                ref="newsRightpopup">
                <router-view ref="currentItem"></router-view>
                <div class="d-flex" slot="header">
                  <button type="button" style="border: none; background-color: transparent" @click="handleSidebarHide">
                    <i class="icon-close f-14"></i>
                  </button>
                </div>
              </b-sidebar>
            </div>
          </div>
        </div>
      </template>
    </visitorPermission>
    </b-overlay>
  </div>
</template>
<script>
import newsListing from "./newsListing";
import { adService } from "../../_services";
import { AlertDialog } from "@/_helpers/AlertDialog";

export default {
  mixins: [AlertDialog],
  components: {
    newsListing,
  },
  data() {
    return {
      sidebarMenu: this.currentRouteName != "NewsInfoCenter",
      newsActiviateLimit: 0,
      packageCode: '',
      loadingSponsor:false,
    };
  },
  watch: {
    currentRouteName: {
      handler() {
        this.sidebarMenu = this.currentRouteName != "NewsInfoCenter";
      },
    },
    sidebarMenu: {
      handler() {
        this.$nextTick(() => {
          this.sidebarMenu = this.currentRouteName != "NewsInfoCenter";
        });
      },
    },
  },
  created() {
    this.sidebarMenu = this.currentRouteName != "NewsInfoCenter";
    this.LoadSponsorGrad();
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    user() {
      return this.$store.state.authentication.user;
    },
    isAdmin() {
      return this.user.userType == "ADMIN";
    },
  },
  methods: {
    LoadSponsorGrad() {

      if (!this.isAdmin) {
        this.loadingSponsor = true;
        adService.GetPackageByCompanyId({ empCompanyId: this.user.empCompanyId }).then((res => {
          
          if (res.isSuccessful) {
            var data = res.data;
            this.packageCode = data.basicInfo.sponsorshipGroup;
            if (this.packageCode == 'Blue Diamond Sponsorship') {
              this.newsActiviateLimit = 7
            } else if (this.packageCode == 'Diamond Sponsorship') {
              this.newsActiviateLimit = 6
            } else if (this.packageCode == 'Platunum Sponsorship') {
              this.newsActiviateLimit = 4
            } else {
              this.newsActiviateLimit = 0
            }
          }
        })).finally(() => {
          this.loadingSponsor = false
        })
      }
    },
    hideSidebarNavMenu() {
      this.$refs["newsRightpopup"].hide();
      this.$router.replace("/newsInfoCenter/default");
      // this.sidebarMenu = false;
    },
    refresh() {
      return this.$refs.news.LoadNewsData();
    },
    openSidebarAfterSave() {
      this.$root.$emit("bv::toggle::collapse", "newsRightpopup");
    },
    handleSidebarHide() {
      if (this.$refs.currentItem.dirty) {
        this.showLeavePage().then((result) => {
          if (result.isConfirmed) {
            this.$refs["newsRightpopup"].hide();
            this.$router.replace("/newsInfoCenter/default");
          }
        });
      } else {
        this.$refs["newsRightpopup"].hide();
        this.$router.replace("/newsInfoCenter/default");
      }
    },
  },
};
</script>
